import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_CHECKOUT = `${URL_RETAILER_SCOPED}/checkout`
// @hygen:inject scoped-urls

const URL_CHECKOUT_ADMIN = `${URL_APP_ADMIN}/checkout`
const URL_CHECKOUT_ADMIN_DIGITAL_GIFT_CARD_UPLOAD = `${URL_CHECKOUT_ADMIN}/digital-gift-card-upload`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'checkout'>
  | DashRouteType<'app-admin-checkout'>
  | DashRouteType<'app-admin-checkout-digital-gift-card-upload'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  checkout: URL_CHECKOUT,
  'app-admin-checkout': URL_CHECKOUT_ADMIN,
  'app-admin-checkout-digital-gift-card-upload': URL_CHECKOUT_ADMIN_DIGITAL_GIFT_CARD_UPLOAD,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
